var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('realTime',{ref:"callpolice"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }